import React from "react";
import { useNavigate } from "react-router-dom";
import { Plane, Star, Wrench, CloudUpload, Settings as SettingsIcon, ChevronRight, LogOut, ScanFace, Shield } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useSettings } from "@/contexts/SettingsContext";

const ITEMS = [
  { to: "/kiosk", label: "Kiosk Scan", icon: ScanFace, color: "#22D3A5", roles: ["admin", "hr_manager"] },
  { to: "/leaves", label: "Leave Manager", icon: Plane, color: "#4F8EF7" },
  { to: "/holidays", label: "Holidays", icon: Star, color: "#9B6FEB" },
  { to: "/regularization", label: "Regularization", icon: Wrench, color: "#F7C94F" },
  { to: "/backup", label: "Backup & Restore", icon: CloudUpload, color: "#F75A5A", roles: ["admin", "hr_manager"] },
  { to: "/audit-log", label: "HR Activity Log", icon: Shield, color: "#22D3A5", roles: ["admin"] },
];

const ROLE_LABEL = { admin: "Admin", hr_manager: "HR Manager", employee: "Employee" };

export default function More() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const { settings } = useSettings();
  const visibleItems = ITEMS.filter((it) => !it.roles || it.roles.includes(user?.role));

  return (
    <div className="px-4 pt-3 pb-4 space-y-4" data-testid="more-page">
      <div className="rounded-2xl p-4 flex items-center gap-3" style={{ background: "#161B2C", border: "1px solid #1E2640" }}>
        <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold font-syne text-lg" style={{ background: "#4F8EF7", color: "#fff" }}>
          {user?.name?.charAt(0).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-bold truncate" style={{ color: "#E8ECFF" }}>{user?.name}</div>
          <div className="text-xs truncate" style={{ color: "#7A85A3" }}>{user?.mobile} · {ROLE_LABEL[user?.role] || user?.role}</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {visibleItems.map((it) => (
          <button key={it.to} onClick={() => nav(it.to)} data-testid={`quick-${it.to.replace("/", "")}`}
            className="rounded-2xl p-4 text-left active:scale-[0.98] transition-transform"
            style={{ background: "#161B2C", border: "1px solid #1E2640" }}>
            <it.icon size={24} style={{ color: it.color }} className="mb-3" />
            <div className="font-bold text-sm" style={{ color: "#E8ECFF" }}>{it.label}</div>
          </button>
        ))}
      </div>

      <button onClick={() => nav("/settings")} data-testid="open-settings"
        className="w-full rounded-2xl p-4 flex items-center gap-3"
        style={{ background: "#161B2C", border: "1px solid #1E2640" }}>
        <SettingsIcon size={20} style={{ color: "#4F8EF7" }} />
        <div className="flex-1 text-left">
          <div className="font-bold" style={{ color: "#E8ECFF" }}>Settings</div>
          <div className="text-xs" style={{ color: "#7A85A3" }}>{settings?.company_name || "Company"} · Work {settings?.work_start_time}–{settings?.work_end_time}</div>
        </div>
        <ChevronRight size={18} style={{ color: "#7A85A3" }} />
      </button>

      <button onClick={logout} data-testid="signout-button"
        className="w-full h-12 rounded-xl font-bold flex items-center justify-center gap-2"
        style={{ background: "rgba(247,90,90,0.1)", color: "#F75A5A", border: "1px solid rgba(247,90,90,0.3)" }}>
        <LogOut size={16} /> Sign Out
      </button>
    </div>
  );
}
